import React from 'react';
import ArrowDown from '../../assets/arrow-down.svg';
import ArrowUp from '../../assets/arrow-up.svg';

function ExpandIcon({ isActive }) {
  return <img alt="Open/Close collapse" src={isActive ? ArrowUp : ArrowDown} />;
}

export default ExpandIcon;
